import { useMemo } from "react";
import SentryEchart from "../../../../../components/echarts/sentry-echart.jsx";
import useGraphViewportWidth from "../../../../../hooks/use-graph-viewport-width.js";
import {
    DASH_BREAKPOINTS,
    fluidPx
} from "../../../../../utils/responsive-graph.js";

export default function PassageSearchCard({ passageSearch }) {
    const vw = useGraphViewportWidth();
    const isCompact = vw < DASH_BREAKPOINTS.desktop;
    const rawValue = typeof passageSearch === "number"
        ? passageSearch
        : passageSearch?.passageSearch;
    const value = Number(rawValue) || 0;

    const option = useMemo(() => {
        const numFs = isCompact ? 16 : fluidPx(20, 36, vw);
        const ringWidth = isCompact ? 8 : fluidPx(8, 24, vw);

        const detailOffsetY = isCompact ? 4 : 3;

        return {
            animation: true,

            tooltip: {
                show: false
            },

            title: {show: false},

            series: [
                {
                    type: "gauge",

                    min: 0,
                    max: value || 1,

                    startAngle: 225,
                    endAngle: -45,

                    center: ["50%", isCompact ? "53%" : "55%"],

                    radius: isCompact ? 40 : 54,

                    silent: true,

                    progress: {
                        show: true,
                        width: ringWidth,
                        roundCap: true,

                        itemStyle: {
                            color: {
                                type: "linear",
                                x: 0,
                                y: 0,
                                x2: 1,
                                y2: 0.75,

                                colorStops: [
                                    {
                                        offset: 0.1773,
                                        color: "#1CEAE6"
                                    },
                                    {
                                        offset: 0.2927,
                                        color: "#3E98D9"
                                    },
                                    {
                                        offset: 0.385,
                                        color: "#0080ED"
                                    },
                                    {
                                        offset: 0.702,
                                        color: "#003878"
                                    }
                                ]
                            },

                            shadowBlur: isCompact ? 6 : 10,
                            shadowColor: "rgba(0, 0, 0, 0.5)",
                            shadowOffsetY: isCompact ? 2 : 5
                        }
                    },

                    axisLine: {
                        show: false
                    },

                    pointer: {
                        show: false
                    },

                    axisTick: {
                        show: false
                    },

                    splitLine: {
                        show: false
                    },

                    axisLabel: {
                        show: false
                    },

                    anchor: {
                        show: false
                    },

                    detail: {
                        show: true,
                        valueAnimation: true,

                        offsetCenter: [0, detailOffsetY],

                        formatter: (currentValue) => {
                            const formattedValue = Math.round(
                                currentValue
                            ).toLocaleString("pt-BR");

                            return `{numero|${formattedValue}}`;
                        },

                        rich: {
                            numero: {
                                fontSize: numFs,
                                fontWeight: "bold",
                                color: "#E8E8E8",
                                lineHeight: numFs
                            }
                        }
                    },

                    data: [
                        {
                            value
                        }
                    ]
                }
            ]
        };
    }, [isCompact, value, vw]);

    return (
        <article className="col-start-2 row-start-1 min-h-0 h-full flex flex-col items-center">
            <SentryEchart
                className="flex-1 min-h-0 w-full"
                option={option}
            />
            <h4 className={`text-center shrink-0 text-[#AAAAAA] ${isCompact ? "text-[12px]! leading-[12px] font-normal" : "text-(length:--font-xs)"}`}>
                Pesquisa de passagens
            </h4>
        </article>
    );
}
